<div *ngIf="actionSetting$ | async as actionSettings">
   <div class="row">
      <label class="sam-margin-left-medium sam-center-left" fxFlex="40%" for="{{ actionId }}-tag-name">{{
         'user_actions.types.set_tag.settings.tag_name' | translate
      }}</label>
      <input
         fxFlex="60%"
         [value]="actionSettings.tagName"
         (input)="tagNameChanged(actionSettings, $event.target.value)"
         kendoTextBox
      />
   </div>

   <div class="row">
      <label class="sam-margin-left-medium sam-center-left" fxFlex="40%" for="{{ actionId }}-tag-value">{{
         'user_actions.types.set_tag.settings.tag_value' | translate
      }}</label>
      <input
         fxFlex="60%"
         [value]="actionSettings.tagValue"
         (input)="tagValueChanged(actionSettings, $event.target.value)"
         kendoTextBox
      />
   </div>
</div>
